import { render, staticRenderFns } from "./CreateChannel.vue?vue&type=template&id=2338c98a&scoped=true&"
import script from "./CreateChannel.vue?vue&type=script&lang=js&"
export * from "./CreateChannel.vue?vue&type=script&lang=js&"
import style0 from "./CreateChannel.vue?vue&type=style&index=0&id=2338c98a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338c98a",
  null
  
)

export default component.exports